<template>
  <div id="app" >


      <div class="nav">
                      <div @click="gohome">
                            <img  class="login-img" src="../static/imgs/login.png" alt="">
                            <span class="login-text">前寶通(香港)有限公司</span>
                      </div>

                       <div  class="nav-left">
                            <div @click="book">
                              <img class="nav-img" src="../static/imgs/f.png" alt="">
                            </div>
                            <div @click="Whatsapp">
                              <img  class="nav-img" src="../static/imgs/whatsapp.png" alt="">
                            </div>
                            <div @click="wei">
                              <img  class="nav-img" src="../static/imgs/wei.png" alt="">
                            </div>
                            <div @click="phone">
                              <img  class="nav-img" src="../static/imgs/dianhua.png" alt="">
                            </div>
                      </div>

      </div>

     <div  >
              <swiper class="swiper" ref="Swiper" :options="swipertion">

                     <!-- <swiper-slide class="swiper-slide ">

                          <div>
                              <img class="nth01" src="../static/imgs/runbo1.png" alt="">
                          </div>
                         <div class="run-ke">
                           <div class="run-hu1"> 網站/網店開發及管理</div>
                           <div class="run-ser"> E-SHOP MANAGE</div>


                       </div>

                    </swiper-slide> -->
                     <swiper-slide class="swiper-slide ">
                       <div>
                              <img class="nth01" src="../static/imgs/runbo2.png" alt="">
                          </div>

                          <div class="run-ke1">
                           <div class="run-hu"> 電子支付</div>
                           <div class="run-ser">ELECTRONIC PAYMENT</div>


                       </div>

                    </swiper-slide>
                     <swiper-slide class="swiper-slide ">
                           <div>
                              <img class="nth01" src="../static/imgs/runbo3.png" alt="">
                          </div>

                         <div class="run-ke1">
                           <div class="run-hu">庫存物流管理</div>
                           <div class="run-ser">INVENTORY & LOGISTICS</div>


                       </div>

                    </swiper-slide>
                     <swiper-slide class="swiper-slide ">
                       <div>
                              <img class="nth01" src="../static/imgs/runbo4.png" alt="">
                          </div>

                         <div class="run-ke1">
                           <div class="run-hu"> 客戶服務和支援</div>
                           <div class="run-ser">CUSTOMER SERVICE AND SUPPORT</div>


                       </div>

                    </swiper-slide>
                     <swiper-slide class="swiper-slide ">
                       <div>
                              <img class="nth01" src="../static/imgs/runbo5.png" alt="">
                          </div>

                          <div class="run-ke1">
                           <div class="run-hu"> 市場推廣</div>
                           <div class="run-ser">MARKETING </div>


                       </div>

                    </swiper-slide>

         <div class="swiper-pagination" slot="pagination"></div>
       </swiper>

      </div>
        <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
   return{
         list:[{ name:'首頁', cm:"demo"},
      { name:'業務範圍', cm:"demo1"},
      { name:'優勝之處', cm:"demo2"},
      { name:'策略合作夥伴', cm:"demo3"},
      { name:'最新動態', cm:"demo4"},
      { name:'關於我們', cm:"demo5"},
      { name:'商業合作夥伴', cm:"demo6"},
      { name:'聯絡我們', cm:"demo7"},

            ],
            imgs:false,
      swich:false,
      nav:false,
       screenWidth: document.body.clientWidth,
      //  screenWidth:true,
       offsetWidth: document.body.clientWidth,
      direction:'horizontal',
      realIndex:0,
      swipertion: {
          autoplay:true,
          direction: 'horizontal',
          loop:true,
        mode:"horizontal",
        delay: 3000,
          pagination: {
            el: '.swiper-pagination',
            clickable:true
          }
        },
   }
  },
  created(){

  },
  mounted(){

  },
  watch: {

        },
  methods: {
         gohome(){
             if(window.location.pathname=='/home'){

             }else{
                 this.$router.push("/home");
             }

         },
      phone(){
        window.location.href = 'tel:+852 5371 8008';
       },
    what(){
          this.imgs=!this.imgs;
    },
    Whatsapp(){
       window.open('https://api.whatsapp.com/send?phone=85253718008')
    },
    wei(){
         window.open('https://weibo.com/u/6632850671')
    },
    book(){
      window.open('https://www.facebook.com/UniversalPocketHK')
    },
       ScrollTop (number = 0, time)  {
    if (!time) {
        document.body.scrollTop = document.documentElement.scrollTop = number;
        return number;
    }
    const spacingTime = 20; // 设置循环的间隔时间  值越小消耗性能越高
    let spacingInex = time / spacingTime; // 计算循环的次数
    let nowTop = document.body.scrollTop + document.documentElement.scrollTop; // 获取当前滚动条位置
    let everTop = (number - nowTop) / spacingInex; // 计算每次滑动的距离
    let scrollTimer = setInterval(() => {
        if (spacingInex > 0) {
            spacingInex--;
           this. ScrollTop(nowTop += everTop);
        } else {
            clearInterval(scrollTimer); // 清除计时器
        }
    }, spacingTime);
},



     changeIndex (index) {
        if(window.location.pathname=='/home'){
               this.realIndex=0;
        console.log(index)
       if(index==0){
           this.ScrollTop(0, 800);
       }else if(index==1){
           this.ScrollTop(800, 800);
       }else if(index==2){
           this.ScrollTop(2226, 800);
       }else if(index==3){
           this.ScrollTop(2712, 800);
       }else if(index==4){
           this.ScrollTop(3360, 800);
       }else if(index==5){
           this.ScrollTop(4240, 800);
       }else if(index==6){
           this.ScrollTop(5100, 800);
       }else if(index==7){
           this.ScrollTop(5700, 800);
       }
        }else{
          this.$router.push("/home")
        }

       },
  },
}
</script>
<style >
html {overflow-x:hidden;}
 body{
   margin: 0 !important;
   padding: 0 !important; }
.swiper-pagination-fraction,
.swiper-pagination-custom,
.swiper-container-horizontal > .swiper-pagination-bullets {
  bottom: 20px !important;
  left: 0;
  width: 100%;
}
    .swiper-pagination-bullet {
    width: 40px !important;
    height: 3px !important;
    display: inline-block;
    border-radius: 0px !important;
    background: #fff !important;
    opacity: 1 !important;
}
.swiper-pagination-bullet-active {

    background: #00dfb9 !important;
}
 </style>

<style  scoped>
.run-ke{
  position: absolute;
  top:80px;
  left:24.5px;
  z-index: 9;
}
.run-ke1{
   position: absolute;
  top:76px;
  left:24.5px;
  z-index: 9;
}
.run-hu1{
      text-align: left;
  width: 220px;
  color: #fff;
  font-family: AlibabaPuHuiTiR;
  font-size: 20px;
}
.run-hu{
  text-align: left;
  width: 220px;
  color: #fff;
  font-family: AlibabaPuHuiTiR;
  font-size: 20px;
}
.run-ser{
  margin-top:10px;
  color: #ffffff;
  font-size: 12px;
  font-family: AlibabaPuHuiTiR;
}
.nth01{
   width: 100%;
   height: 199.5px;
}
.swiper-slide {
  position: relative;
  width: 100%;
  height: 200px;
}
.nav{
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 49px;
  align-items: center;
}
.login-text{
  color: #141414;
  font-size: 15px;
  font-family: AlibabaPuHuiTiM;
  font-weight: bold;
}
.nav-left{
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.nav-img{
  width: 29px;
  height: 29px;
  margin-right:10px;
}
.login-img{
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue